module.exports = __webpack_public_path__ + "img/pdf-file-icon.68db5743.svg";